"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles = {
    root: {
        borderRadius: "0.375rem",
        backgroundColor: "#F9FAFB",
        border: "1px solid #D0D5DD",
        color: "#344054",
        cursor: "pointer",
        fontSize: "14px",
        // Apply this so implementers may use containers and layouts to determine button size, as well as overrides
        height: "auto",
        padding: "10px 20px",
        fontWeight: 600,
        // Apply this so implementers may use containers and layouts to determine button size, as well as overrides
        width: "100%",
    },
};
exports.default = styles;
//# sourceMappingURL=styles.js.map